import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import { Tooltip } from "bootstrap";

const SwIconButton = ({
  as = "button",
  href,
  onClick,
  disabled = false,
  loading = false,

  size = "md",
  variant = "default",

  tooltip,

  className = "",
  type = "button",
  children,
  ...rest
}) => {
  const isDisabled = disabled || loading;
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (tooltip && tooltipRef.current) {
      const instance = new Tooltip(tooltipRef.current);
      return () => instance.dispose();
    }
  }, [tooltip]);

  const classes = classNames(
    "SwIconBox",
    `SwIconBox--${size}`,
    `SwIconBox--${variant}`,
    loading && "SwIconBox--loading",
    isDisabled && "SwIconBox--disabled",
    className
  );

  const content = loading ? <span className="sw-btn-spinner" /> : children;

  const Element =
    as === "a" ? "a" : "button";

  return (
    <Element
      ref={tooltip ? tooltipRef : null}
      className={classes}
      type={as === "button" ? type : undefined}
      href={as === "a" && !isDisabled ? href : undefined}
      onClick={!isDisabled ? onClick : undefined}
      disabled={as === "button" ? isDisabled : undefined}
      data-bs-toggle={tooltip ? "tooltip" : undefined}
      data-bs-placement="top"
      title={tooltip}
      {...rest}
    >
      {content}
    </Element>
  );
};

export default SwIconButton;
